import "../../../pages/offerings/offerings.css";
const AboutEDMR = (
  <div>
    <p className="transition-text">
      EMDR Intensives are designed for adults who have been doing the work but
      still feel stuck. If weekly 50-minute sessions feel too interrupted to
      create momentum, an Intensive may be an option to consider.
      <br />
      <br />
      They offer a personalized, focused approach to healing that is tailored to
      your unique needs and goals.
      <br />
      <br />
      Designed to help you make meaningful progress in a shorter period of time,
      intensives provide dedicated space to address the experiences that may be
      keeping you stuck in patterns of distress, overwhelm, or survival mode.
      <br />
      <br />
      Through EMDR therapy, distressing memories and experiences can be processed
      and reworked, allowing for greater emotional regulation, increased
      self-awareness, and a stronger sense of connection to yourself and others.
      <br />
      <br />
      EMDR Intensives typically include:
    </p>
    <ul className="transition-text">
      <li>Pre-Intensive Planning Session</li>
      <li>4–6 Hour Intensive Therapy Session</li>
      <li>Follow-Up Integration Session</li>
    </ul>
    <p className="transition-text">
      Clients are welcome to travel to either our Augusta or Kennesaw location.
    </p>
  </div>
);

export default AboutEDMR;
